import React, { useEffect, useState } from "react";
import circle from "../../../assets/img/circulogris.png";
import Options from "../Options/Options";
import "./CardList.css";

const CardList = ({
  Icon = "",
  defaultImg = circle,
  options = [],
  picture = "",
  textOne,
  textTwo,
  text = "",
  style = '',
  onClick,
  hasOnClick = true
}) => {
  const [isHover, setIsHover] = useState(false);
  const [textStyleHover, setTextStyleHover] = useState('')
  return (
    <div
      className={`content-card-list ${style.content} ${(options.length ===0 && !onClick) && style.pointer_none}`}
      onMouseLeave={() => setIsHover(false)}
      onMouseEnter={() => setIsHover(true)}
    >
      {((isHover && options.length != 0) || (isHover && hasOnClick)) && <Hover options={options} onClick={onClick} />}
      <div className={`${!style ? 'content-img-card-list' : ''} ${style.content_img}`} onClick={onClick}>
        {defaultImg != null && picture && (
          <img
            alt="img"
            className={`img-content-card-list ${style.img}`}
            onError={(e) => (e.target.src = defaultImg)}
            src={picture}
          ></img>
        )}
        {Icon && <Icon className={`${style.icon}`} />}
      </div>
      <div
        className={`${style ? `${(isHover && hasOnClick) ? `${style.contet_text_hover}` : `${style.contet_text}`}` : 'content-name-card-list'} scroll-menu`}
        onClick={onClick}
      >
        {textOne ? (
          <div className={`${(!style) ? 'content-text-card-list' : ''} ${style.text}`}>
            <div className="text-one-card-list">{textOne}</div>
            <div className="text-two-card-list">{textTwo}</div>
          </div>
        ) : (
          <div className={`${(style) ? `${isHover ? `${style?.text_hover}` : `${style.text}`}` : 'content-text-card-list'}   `}>
            <div className={`${(!style) ? 'text-one-card-list' : ''}`}>{text}</div>
          </div>
        )}
      </div>
    </div>
  );
};
const Hover = ({ options, onClick }) => {
  console.log()
  return (
    <div>
      <div className="post-masory-card-hover-options">
        {(options.length != 0) && <Options style={{ position: "relative" }} options={options} />}
      </div>
      <div className={`post-masory-card-hover`}
        onClick={onClick}>
      </div>
    </div>
  );
};

export default CardList;
